import React from 'react';
import { Link } from 'react-router-dom';
import './CTA.css';

const CTA = () => {
  return (
    <section className="cta section">
      <div className="cta-bg"></div>
      <div className="container">
        <div className="cta-content">
          <h2 className="cta-title">
            НЕ ЖДИ ПОНЕДЕЛЬНИКА.<br/>
            <span className="highlight">НАЧНИ ПРЯМО СЕЙЧАС.</span>
          </h2>
          <p className="cta-text">
            Каждый день, который ты откладываешь — это день без прогресса.<br/>
            Присоединяйся к тысячам людей, которые уже меняют свою жизнь с FitHousse.
          </p>
          <div className="cta-buttons">
            <Link to="/app" className="btn-primary btn-large">
              Начать Трансформацию
            </Link>
            <p className="cta-note">
              14 дней бесплатно • Отмена в любой момент • Возврат денег гарантирован
            </p>
          </div>
          <div className="cta-social-proof">
            <div className="social-proof-item">
              <div className="avatars">
                <span className="avatar">👤</span>
                <span className="avatar">👤</span>
                <span className="avatar">👤</span>
                <span className="avatar">👤</span>
                <span className="avatar-more">+10K</span>
              </div>
              <p className="social-proof-text">
                Присоединились на этой неделе
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
